export enum ColumnPositionAlignment {
  Start = 'start',
  Center = 'center',
  End = 'end',
}
